/**
 * Created by pablo on 8/22/17.
 */

var integrateShopify;
var form = "integrate_shopify_form";
(function ($, undefined) {
    'use strict';

    integrateShopify = {};
    integrateShopify.form = $("#"+form);
    integrateShopify.redirect = function(e){
                                    e.preventDefault();
                                    let shopify_client_id = process.env.MIX_SHOPIFY_CLIENT_ID;

                                    if($("#shopify_client_id").val() !== "") {
                                        shopify_client_id = $("#shopify_client_id").val();
                                    }

                                    if($("#shopify_shop_name").val() !== ""){
                                        window.location = "https://"+$("#shopify_shop_name").val()+".myshopify.com/admin/oauth/"
                                        +"authorize?client_id="+shopify_client_id+"&scope=write_orders,read_customers,read_products,read_inventory,write_inventory,write_products,read_checkouts,read_locations"
                                            +"&redirect_uri=https://"+ window.location.host +"/shopify/register&state=ugogugb";
                                    }
                                    else{
                                        alert("Por favor ingresa el nombre de tu tienda");
                                    }
                            };

    //binding
    integrateShopify.form.on('submit', integrateShopify.redirect);

})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/shopify.integrate.js